export default __webpack_public_path__ + "static/media/error.0fc233ee.mp3";